export default "__VITE_ASSET__d70c076a__"